import { render, staticRenderFns } from "./CreateBCRLink.vue?vue&type=template&id=34eb7b06&"
import script from "./CreateBCRLink.vue?vue&type=script&lang=js&"
export * from "./CreateBCRLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports